const messages = {
  en: {
    home: 'Support Center',
    sales: 'Sales Help',
    select: 'Select Product',
    tutorials: 'Tutorials',
    faqs: 'FAQs',
    guides: 'Guides',
    videos: 'Videos',
    start: 'Getting Started',
    landing: 'Account Help',
    overview: 'Overview',
    expresshelp: 'Express Help',
    more: 'More',
    close: 'Close',
    empty: 'Nothing Found'
  },
  'es-ud': {
    home: 'Centro de Apoyo',
    sales: 'Asistencia en Compra',
    select: 'Seleccionar Product',
    tutorials: 'Tutoriales',
    faqs: 'FAQs',
    guides: 'Guías',
    videos: 'Videos',
    start: 'Empezar',
    landing: 'Asistencia en Cuenta',
    overview: 'Resumen',
    expresshelp: 'Ayuda Express',
    more: 'Más',
    close: 'Cerrar',
    empty: 'Nada Encontrado'
  },
  es: {
    home: 'Centro de Apoyo',
    sales: 'Asistencia en Compra',
    select: 'Seleccionar Product',
    tutorials: 'Tutoriales',
    faqs: 'FAQs',
    guides: 'Guías',
    videos: 'Videos',
    start: 'Empezar',
    landing: 'Asistencia en Cuenta',
    overview: 'Resumen',
    expresshelp: 'Ayuda Express',
    more: 'Más',
    close: 'Cerrar',
    empty: 'Nada Encontrado'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/SubHeader/messages.js